module.exports = __webpack_public_path__ + "c8dc710954bac2eb7c9d4161efe7afba.jpg";